import React from 'react'

export const Loaders = () => {
  return (
    <section className=" py-20 dark:bg-dark">
      <div className="container flex justify-center">

         

          <div>
            <svg
              className="animate-spin"
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_2592_7119)">
                <path
                  opacity="0.21"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.6167 3.41261C13.4243 3.46611 13.2363 3.52834 13.0462 3.59716C12.325 3.84156 11.5393 3.46016 11.2883 2.73675C11.0373 2.01334 11.4253 1.22983 12.1487 0.978842C12.3716 0.898919 12.5924 0.825574 12.8176 0.760965C13.5521 0.542761 14.3204 0.954906 14.5473 1.685C14.7655 2.41952 14.3512 3.1944 13.6167 3.41261Z"
                  fill="#3758F9"
                />
                <path
                  opacity="0.25"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18.338 2.76738C18.1344 2.7662 17.9395 2.7606 17.7403 2.76816C16.9785 2.78071 16.3471 2.17303 16.3302 1.40248C16.3176 0.640671 16.9319 0.011477 17.6937 -0.0010687C17.9279 -0.00442288 18.1622 -0.00777677 18.4008 -0.00239576C19.1672 0.0156861 19.768 0.649783 19.7499 1.41613C19.7384 2.18463 19.1043 2.78546 18.338 2.76738Z"
                  fill="#3758F9"
                />
                <path
                  opacity="0.28"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M24.7921 2.77031C24.5396 3.49623 23.7511 3.8789 23.0274 3.61978L22.4616 3.43431C21.7249 3.21467 21.3161 2.4395 21.5423 1.70496C21.7663 0.977003 22.5349 0.565972 23.2695 0.792195C23.3835 0.822278 23.4953 0.85894 23.6071 0.895602C23.719 0.932264 23.8308 0.968926 23.9405 1.01217C24.6664 1.2647 25.0425 2.05098 24.7921 2.77031Z"
                  fill="#3758F9"
                />
                <path
                  opacity="0.3"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M29.1717 5.61215C28.7018 6.22311 27.8333 6.33908 27.2267 5.87797C27.0707 5.75395 26.9103 5.6431 26.7455 5.5235C26.1172 5.08439 25.9619 4.22477 26.4075 3.5986C26.8467 2.97028 27.7063 2.81495 28.3346 3.25406C28.5301 3.39101 28.7169 3.53239 28.9037 3.67376C29.5103 4.13488 29.6328 5.00561 29.1717 5.61215Z"
                  fill="#3758F9"
                />
                <path
                  opacity="0.33"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M32.4452 9.67232C31.8146 10.1067 30.9556 9.94901 30.5191 9.32504C30.4066 9.15702 30.2919 8.99559 30.1685 8.83857C29.7058 8.22787 29.8306 7.3581 30.4413 6.89531C31.0564 6.44125 31.9196 6.56394 32.3824 7.17464C32.5256 7.36002 32.6601 7.54982 32.7925 7.7462C33.2269 8.37674 33.0757 9.23789 32.4452 9.67232Z"
                  fill="#3758F9"
                />
                <path
                  opacity="0.38"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M34.315 14.5474C33.5805 14.7656 32.8056 14.3513 32.5874 13.6167C32.5317 13.4309 32.4717 13.2364 32.4029 13.0463C32.1584 12.325 32.5399 11.5393 33.2633 11.2884C33.9867 11.0374 34.7702 11.4254 35.0212 12.1488C35.1011 12.3717 35.1744 12.5924 35.239 12.8176C35.4573 13.5521 35.0451 14.3204 34.315 14.5474Z"
                  fill="#3758F9"
                />
                <path
                  opacity="0.42"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M34.5817 19.7565C33.822 19.7406 33.2146 19.1044 33.2326 18.338C33.2317 18.141 33.2394 17.9395 33.2319 17.7403C33.2193 16.9785 33.827 16.3472 34.5954 16.3368C35.3593 16.3177 35.9885 16.9319 36.0011 17.6937C36.0044 17.928 36.0078 18.1622 36.0024 18.4009C35.9843 19.1672 35.3481 19.7746 34.5817 19.7565Z"
                  fill="#3758F9"
                />
                <path
                  opacity="0.55"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M35.2144 23.2716L34.9945 23.9426C34.7353 24.6664 33.9491 25.0425 33.2297 24.7921C32.5038 24.5395 32.1211 23.7511 32.3803 23.0274L32.5657 22.4616C32.7854 21.7249 33.5605 21.316 34.2951 21.5422C35.023 21.7663 35.4341 22.5349 35.2144 23.2716Z"
                  fill="#3758F9"
                />
                <path
                  opacity="0.65"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M32.746 28.3346C32.609 28.5301 32.4677 28.7169 32.3263 28.9037C31.863 29.5168 30.9944 29.6328 30.3879 29.1717C29.7769 28.7018 29.661 27.8333 30.1221 27.2267C30.2461 27.0707 30.3569 26.9103 30.4765 26.7455C30.9157 26.1172 31.7797 25.9706 32.4014 26.4075C33.0298 26.8467 33.1851 27.7063 32.746 28.3346Z"
                  fill="#3758F9"
                />
                <path
                  opacity="0.7"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M28.8254 32.3824C28.64 32.5256 28.4502 32.6601 28.2538 32.7924C27.6211 33.2334 26.7621 33.0757 26.3277 32.4452C25.8933 31.8146 26.051 30.9556 26.675 30.519C26.843 30.4066 27.0044 30.2919 27.1614 30.1685C27.7721 29.7057 28.6419 29.8306 29.1047 30.4413C29.5588 31.0564 29.4361 31.9196 28.8254 32.3824Z"
                  fill="#3758F9"
                />
                <path
                  opacity="0.8"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M23.8513 35.0211C23.6284 35.1011 23.4076 35.1744 23.1824 35.239C22.4479 35.4572 21.6796 35.0451 21.4527 34.315C21.2345 33.5805 21.6488 32.8056 22.3833 32.5874C22.5757 32.5339 22.7637 32.4716 22.9538 32.4028C23.675 32.1584 24.4607 32.5398 24.7117 33.2632C24.9627 33.9866 24.5747 34.7701 23.8513 35.0211Z"
                  fill="#3758F9"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18.3063 36.0011C18.072 36.0044 17.8378 36.0078 17.5991 36.0024C16.8328 35.9843 16.2319 35.3502 16.25 34.5839C16.2594 33.8219 16.8956 33.2145 17.662 33.2326C17.8634 33.2404 18.0605 33.2394 18.2596 33.2318C19.0215 33.2193 19.6528 33.827 19.6698 34.5975C19.6823 35.3593 19.0681 35.9885 18.3063 36.0011Z"
                  fill="#3758F9"
                />
                <path
                  opacity="0.05"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M14.4577 34.295C14.2337 35.023 13.4651 35.434 12.7284 35.2144L12.0574 34.9944C11.3336 34.7353 10.9575 33.949 11.2079 33.2297C11.4604 32.5038 12.2467 32.1277 12.9726 32.3802L13.5384 32.5657C14.2729 32.7919 14.6839 33.5605 14.4577 34.295Z"
                  fill="#3758F9"
                />
                <path
                  opacity="0.07"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.59241 32.4014C9.1533 33.0297 8.29368 33.1851 7.66535 32.7459C7.46983 32.609 7.28303 32.4676 7.09624 32.3262C6.4897 31.8651 6.36715 30.9944 6.82826 30.3879C7.29811 29.7769 8.16669 29.6609 8.77323 30.122C8.92928 30.246 9.08749 30.3635 9.25444 30.4765C9.88277 30.9156 10.0359 31.7818 9.59241 32.4014Z"
                  fill="#3758F9"
                />
                <path
                  opacity="0.09"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.5587 29.1047C4.94357 29.5587 4.08038 29.436 3.61759 28.8253C3.47436 28.64 3.33987 28.4502 3.20754 28.2538C2.77311 27.6232 2.92427 26.7621 3.55481 26.3277C4.18536 25.8932 5.04435 26.051 5.48093 26.6749C5.59342 26.843 5.70807 27.0044 5.83145 27.1614C6.29424 27.7721 6.1694 28.6419 5.5587 29.1047Z"
                  fill="#3758F9"
                />
                <path
                  opacity="0.11"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2.73681 24.7117C2.0134 24.9627 1.22774 24.5813 0.978907 23.8513C0.898984 23.6284 0.82564 23.4076 0.76103 23.1824C0.542826 22.4479 0.954971 21.6796 1.68507 21.4527C2.41959 21.2345 3.19447 21.6488 3.41267 22.3833C3.46617 22.5757 3.52841 22.7636 3.59722 22.9538C3.84163 23.675 3.46022 24.4607 2.73681 24.7117Z"
                  fill="#3758F9"
                />
                <path
                  opacity="0.13"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M1.40247 19.6698C0.640653 19.6823 0.00930211 19.0747 -0.00108697 18.3063C-0.00444118 18.072 -0.007795 17.8378 -0.00241403 17.5991C0.0156679 16.8328 0.649765 16.2319 1.41611 16.25C2.17587 16.266 2.78544 16.8956 2.76736 17.662C2.76618 17.8656 2.76058 18.0605 2.76814 18.2596C2.78069 19.0215 2.17301 19.6528 1.40247 19.6698Z"
                  fill="#3758F9"
                />
                <path
                  opacity="0.19"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.3251 5.48098C9.15709 5.59347 8.99349 5.7147 8.83863 5.8315C8.22793 6.29429 7.35816 6.16945 6.89537 5.55874C6.44132 4.94362 6.56401 4.08043 7.17471 3.61764C7.36008 3.47441 7.54988 3.33992 7.74626 3.20759C8.37681 2.77316 9.23795 2.92432 9.67238 3.55486C10.1068 4.18541 9.94907 5.0444 9.3251 5.48098Z"
                  fill="#3758F9"
                />
                <path
                  opacity="0.15"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.61977 12.9727L3.43431 13.5384C3.21466 14.2751 2.4395 14.684 1.70496 14.4578C0.976998 14.2337 0.565966 13.4651 0.785611 12.7284L1.00558 12.0574C1.2647 11.3336 2.05097 10.9575 2.77031 11.2079C3.49622 11.4605 3.87889 12.2489 3.61977 12.9727Z"
                  fill="#3758F9"
                />
                <path
                  opacity="0.17"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.87798 8.7733C5.75397 8.92935 5.64095 9.0963 5.52352 9.25451C5.08441 9.88284 4.21821 10.036 3.59646 9.59906C2.96814 9.15995 2.81496 8.29375 3.25407 7.66542C3.39103 7.4699 3.5324 7.2831 3.67378 7.09631C4.13489 6.48977 5.00562 6.36722 5.61 6.83491C6.22312 7.29818 6.3391 8.16676 5.87798 8.7733Z"
                  fill="#3758F9"
                />
              </g>
              <defs>
                <clipPath id="clip0_2592_7119">
                  <rect width="36" height="36" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>

         

      </div>
    </section>
  
  )
}
